function getInnerWidth(el: Element | string | null | undefined) {
  let _el = el
  if (typeof _el === 'string') {
    _el = document.querySelector(_el)
  }
  if (!_el) {
    return 0
  }
  const style = getComputedStyle(_el)
  return (
    Number.parseFloat(style.width) -
    Number.parseFloat(style.paddingLeft) -
    Number.parseFloat(style.paddingRight)
  )
}
const navbar = document.getElementById('main-nav')
const block = navbar?.closest('.wp-block-yellowtree-navbar')
const container = navbar?.querySelector('.main-nav__container')

function getDesktopMenuWidth() {
  if (!navbar || !block) {
    return 0
  }
  const isExpanded = block.classList.contains('navbar--expanded')

  // Force the menu into desktop view
  navbar.classList.toggle('navbar-expand', true)
  block.classList.toggle('navbar--expanded', true)
  const children = document.querySelectorAll(
    '.navbar-brand, .main-nav-megamenu, .main-nav-switcher'
  )
  // offsetWidth is equivalent to getBoundingClientRect().width here, because we are not interested in transforms
  const width = Array.from(children)
    .map((x) => (x as HTMLElement).offsetWidth)
    .reduce((a, b) => a + b, 0)

  // Reset the menu to its original state
  navbar.classList.toggle('navbar-expand', isExpanded)
  block.classList.toggle('navbar--expanded', isExpanded)
  return width
}

const MIN_EXPANDED_WIDTH = 576 // sm breakpoint

function updateState() {
  const containerWidth = getInnerWidth(container)
  const desktopMenuWidth = getDesktopMenuWidth()
  const canExpand =
    containerWidth > desktopMenuWidth + 30 &&
    containerWidth > MIN_EXPANDED_WIDTH
  block?.classList.toggle('navbar--expanded', canExpand)
  navbar?.classList.toggle('navbar-expand', canExpand)

  if (block instanceof HTMLElement) {
    const mobileControlsSection: HTMLElement | null = document.querySelector(
      '.main-nav-offcanvas__controls'
    )
    block.style.setProperty(
      '--icf-navbar-content-offset',
      `${mobileControlsSection?.offsetHeight}px`
    )
  }
}

let animationFrame: ReturnType<typeof requestAnimationFrame>

const resizeObserver = new ResizeObserver(() => {
  cancelAnimationFrame(animationFrame)
  animationFrame = requestAnimationFrame(updateState)
})

if (container) {
  resizeObserver.observe(container, {
    box: 'border-box'
  })
}

updateState()

const menuItemDropdowns = document.querySelectorAll<HTMLElement>(
  '.main-nav-megamenu-nav .main-nav-megamenu__dropdown'
)

const getContentElement = (menuItemElement: HTMLElement) => {
  return menuItemElement.closest<HTMLElement>('.main-nav-megamenu-nav')
}

for (const el of menuItemDropdowns) {
  el.addEventListener('show.bs.dropdown', () => {
    const contentEl = getContentElement(el)
    if (contentEl) {
      contentEl.scrollTop = 0
      contentEl.style.overflow = 'hidden'
    }
  })

  el.addEventListener('hidden.bs.dropdown', () => {
    const contentEl = getContentElement(el)
    if (contentEl) {
      contentEl.style.overflow = ''
    }
  })
}

// Listen on `document`: in the block editor canvas this script runs before
// `document.body` exists. The offcanvas events bubble up to the document.
document.addEventListener('show.bs.offcanvas', (e) => {
  document.body?.classList.toggle('is-showing-offcanvas', true)
})

document.addEventListener('hidden.bs.offcanvas', (e) => {
  document.body?.classList.toggle('is-showing-offcanvas', false)
})
